import { Component, ChangeDetectionStrategy, ElementRef, AfterViewInit, inject } from '@angular/core';
import { PythonExerciseComponent } from '../python-exercise/python-exercise';
import { getFormattedCode, SkyproDecodeHtmlService } from '@skyeng/libs/skypro/shared';

@Component({
  selector: 'skypro-python-before-code',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonBeforeCodeComponent implements AfterViewInit {
  private pythonExerciseComponent = inject(PythonExerciseComponent);
  private skyproDecodeHtmlService = inject(SkyproDecodeHtmlService);
  private elementRef = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    const code = this.skyproDecodeHtmlService.decodeHtml(getFormattedCode(this.elementRef.nativeElement));
    this.pythonExerciseComponent.addBeforeCode(code);
  }
}
